module.exports = "div.wrapper {\n  background-color: #ffffff; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/texteditor/texteditor.component.scss
// module id = ./src/app/components/tools/texteditor/texteditor.component.scss
// module chunks = main